import React, { useEffect, useState } from "react"
import { Avatar, AvatarProps } from "antd"

const PartnerAvatar: React.FC<PartnerAvatarProps> = (props) => {
  const [src, setSrc] = useState<string | undefined>(props.src)

  useEffect(() => {
    if (!props.src) {
      setSrc(`https://ui-avatars.com/api/?name=${props.name}&background=random`)
    }
  }, [props])

  return (
    <Avatar
      src={src}
      {...props}
    />
  )
}

type PartnerAvatarProps = AvatarProps & {
  src?: string
  name: string
}

export default PartnerAvatar